<template>
    <div class="atom-hr container">
        <hr class="text-ash-200 opacity-30" />
    </div>
</template>

<script setup lang="ts"></script>
